<template>
    <TprmModal
        open
        :additional-class-name="additionalClasses"
        :title="header"
        :full-screen="fullScreen"
        @close="close"
    >
        <LogoLoader />
    </TprmModal>
</template>

<style lang="scss">
    .LoadingModal {
        .Modal__content {
            display: flex;
            align-items: center;
            justify-content: center;

            .LogoLoader {
                font-size: 0.5em;
                margin: 0 auto;
            }
        }
    }
</style>

<script lang="ts">
    import { Component, Prop, Vue } from '@evidentid/vue-property-decorator';

    import { LogoLoader } from '@evidentid/dashboard-commons/components/LogoLoader';

    import TprmModal from '@/components/tprm-modal/TprmModal.vue';

    @Component({
        components: {
            TprmModal,
            LogoLoader,
        },
        // PRODUCT-26110 Task 10 (INSTANCE_LISTENERS): `TprmModal`'s own `close` bubbles
        // here and is explicitly re-emitted via `close()` below. Vue 3 merges listeners
        // into `$attrs`, so without `inheritAttrs: false` a caller's `@close` would now
        // ALSO auto-fall-through onto `TprmModal` (the root) as a second listener,
        // double-firing the caller's handler alongside the explicit re-emit. No call
        // site relies on other attrs reaching `TprmModal` (verified: every usage passes
        // only declared props + `@close`).
        inheritAttrs: false,
        // PRODUCT-26110 QA fixes4: declares the `close` event this component `$emit`s --
        // without a declared `emits`, Vue 3 warns "Component emitted event 'close' but it
        // is neither declared in the emits option nor as an 'onClose' prop" every time it
        // fires.
        emits: [ 'close' ],
    })
    export default class LoadingModal extends Vue {
        @Prop({ type: String, default: '' })
        private additionalClassName!: string;

        @Prop({ type: String, default: '' })
        private header!: string;

        @Prop({ type: Boolean, default: false })
        private fullScreen!: boolean;

        private get additionalClasses(): string {
            return this.additionalClassName ? `LoadingModal ${this.additionalClassName}` : 'LoadingModal';
        }

        private close(): void {
            this.$emit('close');
        }
    }
</script>
